<div class="crud-container">
    <ng-content></ng-content>

    @if (showDefaultFab) {
    <button mat-fab class="floatDefault" color="accent" (click)="newEntity()">
        <mat-icon>add</mat-icon>
    </button>
    }
</div>
